const navSocial = function () {
    const $parent = $(".social-fixed");
    const $list = $parent.find(".social-mobile");
    $list.on("click", function () {
        const isActive = $list.hasClass("active");
        $list.toggleClass("active");
        anime({
            targets: $list[0],
            width: isActive ? 38 : 240,
            borderRadius: isActive ? 900 : 24
        });
    })
}

module.exports = navSocial